import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { useParams } from 'react-router';
import { useMobileApi } from '../../../Api/Mobile/useMobileApi';
import { MobileWealthDTO, MobileWealthVovClient } from '../../../ApiOld/Api/ApiServerVov';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingIndicator from '../Shared/LoadingIndicator';
import { Hardware } from '@mui/icons-material';
import CheckIcon from '@mui/icons-material/Check';
import DomainOutlinedIcon from '@mui/icons-material/DomainOutlined';
import DateRangeIcon from '@mui/icons-material/DateRange';
import PersonIcon from '@mui/icons-material/Person';

export interface IMobileWealthDetailProps {
}

export default function MobileWealthDetail(props: IMobileWealthDetailProps) {
    const param = useParams();
    const { t, i18n } = useTranslation();
    const { authorizedMobileEmployeeApi } = useMobileApi(MobileWealthVovClient);
    const [wealth, setWealth] = useState<MobileWealthDTO>();
    const id = Number(param['id']);
    const [loaded, setLoaded] = useState(false);

    const handleLoad = useCallback(() => {
        if (id)
            authorizedMobileEmployeeApi.wealthDetailById(id).then((res) => {
                setWealth(res.wealth);
                setLoaded(true);
            }).catch(() => {
                setLoaded(true);
            });
    }, [authorizedMobileEmployeeApi, id])

    useEffect(() => {
        if (id)
            handleLoad();
    }, [handleLoad, id]);

    if (!loaded) {
        return <LoadingIndicator />
    }

    return (
        <Box sx={{}}>
            <img src={wealth?.imagePreview} alt={t('PhotoIsMissingOrCorrupted')} style={{ width: '100%', maxHeight: '400px', objectFit: 'contain' }} />
            <Stack direction={'column'} spacing={2} alignItems='center' sx={{ p: 2 }}>
                <Stack direction={'column'} spacing={1} width='100%'>
                    <Stack direction="row" spacing={1} alignContent={'center'}>
                        <Hardware sx={{ color: '#FFC600' }} />
                        <Typography sx={{ fontSize: 16, fontWeight: 'bold', lineHeight: 1 }}>{wealth?.code} - {wealth?.name}</Typography>
                    </Stack>
                    {wealth?.employeeCodeAndName ?
                        <Stack direction="row" spacing={1} alignItems={'center'}>
                            <PersonIcon sx={{ color: '#FFC600' }} />
                            <Typography
                                sx={{
                                    fontSize: 15,
                                    lineHeight: 1,
                                    ...(wealth.borrowedByCurrentEmployee && {
                                        color: 'green',
                                    }),
                                }}
                            >
                                {wealth.employeeCodeAndName}
                            </Typography>
                        </Stack>
                        :
                        <Stack direction="row" spacing={1} alignItems={'center'}>
                            <CheckIcon sx={{ color: 'green' }} />
                            <Typography sx={{ fontSize: 15, color: 'green', lineHeight: 1 }}>{t('Available')}</Typography>
                        </Stack>
                    }
                    {wealth?.buildingCodeAndName && (
                        <Stack direction="row" spacing={1} alignItems={'center'}>
                            <DomainOutlinedIcon sx={{ color: '#FFC600' }} />
                            <Typography sx={{ fontSize: 15, lineHeight: 1 }}>{wealth.buildingCodeAndName}</Typography>
                        </Stack>
                    )}
                    {(wealth?.rentDateFrom || wealth?.rentDateTo) && wealth?.employeeCodeAndName &&
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                            <DateRangeIcon sx={{ color: '#FFC600' }} />
                            <Stack direction="row" spacing={1} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                <Typography sx={{ fontSize: 15, lineHeight: 1 }}>
                                    {wealth.rentDateFrom && `${t('from')} ${wealth.rentDateFrom.toLocaleDateString(i18n.language)} `}
                                </Typography>
                                <Typography sx={{ fontSize: 15, lineHeight: 1 }}>
                                    {wealth.rentDateTo && (
                                        <span style={{ color: new Date(wealth.rentDateTo) < new Date() ? 'red' : 'inherit' }}>
                                            {`${t('to').toLowerCase()} ${wealth.rentDateTo.toLocaleDateString(i18n.language)}`}
                                        </span>
                                    )}
                                </Typography>
                            </Stack>
                        </Box>
                    }
                </Stack>
            </Stack>
        </Box>
    );
}
